/**
 * ArtifactServer — DEPRECATED.
 *
 * Artifact serving is now handled by the unified report server (report-server.ts).
 * This file is kept for backward compatibility only.
 *
 * @deprecated Use `startReportServer()` from `./report-server.js` instead.
 */

import { startReportServer } from './report-server.js';
import type { ReportServerHandle } from './report-server.js';

interface ArtifactServerHandle {
  port: number;
  dispose: () => Promise<void>;
}

/**
 * @deprecated Use `startReportServer()` from `./report-server.js` instead.
 */
export async function startArtifactServer(artifactsDir: string): Promise<ArtifactServerHandle> {
  const handle: ReportServerHandle = await startReportServer(artifactsDir);
  return { port: handle.port, dispose: handle.dispose };
}
